import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailNote } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailNote";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";
import { hasAnyDetailValue } from "web_myplann/Shared/Utils/hasAnyDetailValue";

const PageResources = Resources.PortfolioDetail;

type Props = {
	purchaseDate?: string | null;
	description?: string | null;
};

export const PropertyPurchaseDetails: FC<Props> = ({
	purchaseDate,
	description,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	const hasDetails = hasAnyDetailValue(purchaseDate, description);

	if (!hasDetails) {
		return null;
	}

	return (
		<>
			<Typography variant="sectionLabel">
				{t(Resources.DataCard.BasicInfo.additionalInfo)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<DetailRow
					label={t(PageResources.Property.PurchaseDate)}
					value={dateFormatter(purchaseDate)}
				/>
				<DetailNote
					label={t(PageResources.Property.AdditionalDescription)}
					text={description ?? ""}
				/>
			</Stack>
		</>
	);
};
